import { ApiResponse, PaginationModel } from '$models'
import { GridSortModel } from '@mui/x-data-grid-pro'

/**
 * Extracts the pagination data from the ApiResponse headers
 * @param response the ApiReponse with pagination headers
 * @returns the headers parsed to a PaginationModel
 */
export function extractPaginationModel<T>(
  response: ApiResponse<T>
): PaginationModel {
  return {
    page: parseInt(response.headers['pagination-page']),
    pageSize: parseInt(response.headers['pagination-limit']),
    total: parseInt(response.headers['pagination-count']),
  }
}

/**
 * Extracts the sort data from the ApiResponse Headers
 * @param response the ApiReponse with pagination sort headers
 * @returns
 */
export function extractSortModel<T>(response: ApiResponse<T>): GridSortModel {
  const sortHeader = response.headers['pagination-sort']

  if (sortHeader == null) return []

  return sortHeader.split(',').map((sorting) => {
    const split = sorting.split(' ')
    return {
      field: split[0],
      sort: split[1],
    }
  })
}

/**
 * Parses a sort model into a string ready to be sent as a sort query parameter
 * @param sortModel the sort model
 * @returns sort query param
 */
export function parseSortModelToParamString(sortModel: GridSortModel): string {
  let sortString = ''
  sortModel.forEach((sort, i) => {
    sortString += `${sort.field} ${sort.sort}${
      i !== sortModel.length - 1 ? ',' : ''
    }`
  })
  return sortString
}
